export default __webpack_public_path__ + "static/media/slack.979ee211.svg";